<div class="content">
  <div class="mic">
    <mat-icon>mic_off</mat-icon>
  </div>
  <h2 trans="voice_check.dialog.mic_troubleshoot.title">(Title)</h2>
  <p trans="voice_check.dialog.mic_troubleshoot.p1">(Please check:)</p>
  <ul>
    <li trans="voice_check.dialog.mic_troubleshoot.list.item1">(Mic unmuted)</li>
    <li trans="voice_check.dialog.mic_troubleshoot.list.item2">(Mic not in use)</li>
    <!--
    We won't show this specific troubleshooting item until we actually have a way to change microphone.
    <li trans="voice_check.dialog.mic_troubleshoot.list.item3">(Correct microphone selected)</li>
    -->
    <li trans="voice_check.dialog.mic_troubleshoot.list.item4">(Speaking clearly)</li>
  </ul>
  <p trans="voice_check.dialog.mic_troubleshoot.p2">(Your page will now reload.)</p>

</div>
<div class="buttons">
  <button
    type="button"
    class="btn btn-primary btn-wide"
    (click)="close()"
    trans="voice_check.dialog.mic_troubleshoot.ok"
  >(Ok)</button>
</div>
